import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // 用户表数据
    userlist: window.localStorage.getItem("userlist") || null,
    // guid
    user: window.localStorage.getItem("user") || null,
    Qusetionbank: [],
    // userID
    userID: window.localStorage.getItem("userID") || null,
    // hid
    hid: window.localStorage.getItem("hid") || null,
    passworld: "",
    // 用户登录进来是否能看到公告气泡框
    isan: false,
    newMsg: "" // 条数
  },
  mutations: {
    setUserList(state, payload) {
      state.userlist = payload;
      window.localStorage.setItem("userlist", payload);
      //  window.localStorage.setItem('USERID',payload.userID)
    },
    setUser(state, payload) {
      state.user = payload;
      window.localStorage.setItem("user", payload);
      //  window.localStorage.setItem('USERID',payload.userID)
    },
    setUserID(state, payload) {
      state.userID = payload;
      window.localStorage.setItem("userID", payload);
    },
    setHid(state, payload) {
      state.hid = payload;
      window.localStorage.setItem("hid", payload);
    },
    setPass(state, password) {
      state.passworld = password;
    },
    setisan(state, isan) {
      state.isan = isan;
    },
    setiNewMsg(state, newMsg) {
      state.newMsg = newMsg;
    }
  },
  actions: {},
  modules: {}
});
